/**
 * "Surprise Me" — picks a random destination and maps Travel DNA to itinerary params.
 */

const SURPRISE_DESTINATIONS = [
  'Japan', 'Italy', 'France', 'Spain', 'Thailand', 'India', 'Mexico',
  'Greece', 'Turkey', 'Morocco', 'Peru', 'Iceland', 'South Korea',
  'Portugal', 'Croatia', 'Vietnam', 'Indonesia', 'New Zealand',
  'Egypt', 'Brazil', 'Nepal', 'Australia', 'Canada', 'Argentina',
  'Costa Rica', 'Cambodia', 'Sri Lanka', 'Czech Republic', 'Switzerland',
  'Austria', 'Netherlands',
];

const DAYS_OPTIONS = [3, 5, 7];

const pickRandom = (arr) => arr[Math.floor(Math.random() * arr.length)];

/**
 * Map Travel DNA dimensions to itinerary generation parameters.
 */
const mapDNAToParams = (dna) => {
  if (!dna) return {};

  const params = {};

  // Map adventure dimension to itinerary type
  const adventure = dna.adventure || dna.adventureLevel || 50;
  if (adventure > 70) {
    params.itineraryType = 'adventure';
  } else if (adventure < 30) {
    params.itineraryType = 'relaxation';
  } else {
    params.itineraryType = pickRandom(['cultural', 'balanced', 'foodie']);
  }

  // Map budget dimension
  const budget = dna.budget || dna.budgetLevel || 50;
  if (budget > 70) {
    params.budgetRange = 'luxury';
  } else if (budget < 30) {
    params.budgetRange = 'budget';
  } else {
    params.budgetRange = 'mid-range';
  }

  // Travel preferences from DNA
  if (dna.travelPreferences) {
    params.travelPreferences = dna.travelPreferences;
  }

  // Travel personality
  if (dna.travelPersonality) {
    params.travelPersonality = dna.travelPersonality;
  }

  return params;
};

/**
 * Generate surprise itinerary parameters.
 * Reads Travel DNA from localStorage and picks random destination + params.
 */
export const getSurpriseParams = () => {
  let dna = null;
  try {
    dna = JSON.parse(localStorage.getItem('travelDNA') || 'null');
  } catch { /* ignore */ }

  const dnaParams = mapDNAToParams(dna);
  const country = pickRandom(SURPRISE_DESTINATIONS);
  const days = pickRandom(DAYS_OPTIONS);

  return {
    country,
    days,
    itineraryType: dnaParams.itineraryType || 'balanced',
    budgetRange: dnaParams.budgetRange || 'mid-range',
    travelPreferences: dnaParams.travelPreferences || '',
    travelPersonality: dnaParams.travelPersonality || '',
  };
};

export default getSurpriseParams;
